import { render, staticRenderFns } from "./EditNote.vue?vue&type=template&id=57e06fde&scoped=true&"
import script from "./EditNote.vue?vue&type=script&lang=js&"
export * from "./EditNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e06fde",
  null
  
)

export default component.exports